__turbopack_context__.v({
  "actionsFooter": "klVljG_actionsFooter",
  "bar": "klVljG_bar",
  "fitReactions": "klVljG_fitReactions",
  "fitRow": "klVljG_fitRow",
  "footer": "klVljG_footer",
});
